import styled from 'styled-components';

export const StyledSahamTabs = styled.div`
  margin-top: 20px;
  .MuiTabs-flexContainer {
    display: flex;
    align-items: center;
    background: white;
  }
  .MuiTabs-root {
    background-color: #f5f5f5;
  }
  .Mui-selected {
    background-color: #fff;
    border-radius: 1px;
  }
  .rejection-reason-icon {
    color: #d0081b;
  }
  .MuiTab-root {
    max-width: none;
  }
`;

export const EmptyBlocContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  align-items: center;
  text-align: center;
  gap: 20px;
  padding: 25px;
  .bloc-title {
    font-size: 25px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    width: 100%;
  }
`;
